import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { useEffect, useRef, useState } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { useRouter } from 'next/router';
import getConfig from 'next/config'
import Link from 'next/link';
import AccountLayout from './account.layout';
import { Toast } from 'primereact/toast';

const logInByUserName = `${getConfig().publicRuntimeConfig.apiAdminBasePath}login`;

export default function LoginLayout() {
  const [value, setValue] = useState('');
  const router = useRouter()

  const [returnUrl, setReturnUrl] = useState('')
  const toast = useRef<any>()
  const [checked, setChecked] = useState(true)

  useEffect(() => {
    const originUrl = window.location.origin
    const returnUrlQuery = router.query.return_url ?? '/stream/campaign'
    const returnUrlBuilder = `?redirect_url=${originUrl}${returnUrlQuery}`
    setReturnUrl(returnUrlBuilder)

    if (router.query.error_code == '-2') {
      router.push('/validate-top');
    }

    if (router.query.error) {
      toast.current.show({ severity: 'error', summary: router.query.error, life: 3000 })
    }
  }, [])

  return (
    <>
    <Toast ref={toast} />
    <AccountLayout>      
        <form className='w-[550px] mt-[40px]'
            action={`${logInByUserName}${returnUrl}`} method='post'
          >
            <h1 className='text-2xl mb-[40px]'>Đăng nhập</h1>
            <div className="flex flex-column gap-3 mb-[20px]">
              <label className="font-medium" htmlFor="username">Thư điện tử(*)</label>
              <InputText name="username" className="p-inputtext-sm" id="username" />
            </div>
            <div className="flex flex-column gap-3 mb-[10px]">
              <label className="font-medium flex items-center justify-between" htmlFor="password">
                <div>Mật khẩu(*)</div>
                <Link
                    href={'/forget-password'}
                  >
                  <div className='text-cyan-500 hover:underline hover:cursor-pointer'>Quên mật khẩu</div>
                </Link>
              </label>
              <Password name="password" inputClassName="p-inputtext-sm w-full" value={value} onChange={(e) => setValue(e.target.value)} toggleMask />
            </div>
            
            <div className="field-checkbox">
                <Checkbox className="mr-2" inputId="remember-me" name="category" checked={checked} onChange={() => setChecked(!checked)}/>
                <label htmlFor="remember-me">Lưu mật khẩu</label>
            </div>
            <div className='flex flex-col items-center justify-center my-[30px]'>
              <div className='mb-[30px]'>Chưa có tài khoản? 
              <Link
                href={'/register'}
              >
                <span className='text-cyan-500 hover:underline hover:cursor-pointer'> Đăng ký ngay</span>
              </Link>
              </div>
              <div className='mb-[30px]'>Hoặc</div>
              <div>
                <Button className="p-button-outlined p-button-danger" aria-label="Google">
                        <i className="pi pi-google px-2"></i>
                        <span className="px-3">Đăng nhập với Google</span>
                </Button>
              </div>
            </div>
            <div className='flex justify-end'>
              <Button type="submit" label="Đăng nhập" size="small" severity="info" className='p-button-rounded px-[20px]' icon="pi pi-chevron-right" iconPos="right"/>
            </div>
          </form>    
    </AccountLayout>
    </>
  )
}
